"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Header = void 0;
var Header_1 = require("./Header");
Object.defineProperty(exports, "Header", { enumerable: true, get: function () { return Header_1.Header; } });
//# sourceMappingURL=index.js.map